module.exports = __webpack_public_path__ + "static/media/heat.75edff8b.svg";